// Module
var code = "<div class=\"disclaimer-page\"> <div class=\"container\"> <respresso-logo></respresso-logo> <br/> <disclaimer/> </div> </div> ";
// Exports
module.exports = code;